/**
 * 右側欄組件
 * 包含世界觀預覽和推薦偶像
 */
import WorldViewPreview from '@/features/home/components/WorldViewPreview';
import IdolsRecommend from '@/features/home/components/IdolsRecommend';

const RightSidebar = () => {
  return (
    <div>
      <WorldViewPreview />
      <IdolsRecommend />
    </div>
  );
};

export default RightSidebar;
